import React, { useEffect } from 'react';
import Icone from './util/Icone';
import { faWhatsapp, faInstagram, faEnvelope, faUser, faMessage, faGear, faShieldHalved, faCircleQuestion, faLocationDot } from './util/icones';
import logo from '../assets/logo-white.webp';
import logo352 from '../assets/logo-white-352.webp';
import { whatsappUrl } from './util/whatsappUrl';
import { trackWhatsapp } from './util/analytics';

const RA_SCRIPT_ID = "ra-embed-verified-seal";
const FOUNDED_YEAR = 2024;

function Footer() {
  const currentYear = new Date().getFullYear();
  const copyrightYears = currentYear > FOUNDED_YEAR ? `${FOUNDED_YEAR}-${currentYear}` : `${FOUNDED_YEAR}`;

  useEffect(() => {
    const target = document.getElementById("ra-verified-seal");
    if (!target || window.__hawxRaSeal || target.childElementCount > 0) return;
    const carregar = () => {
      if (window.__hawxRaSeal) return;
      window.__hawxRaSeal = true;
      const script = document.createElement("script");
      script.id = RA_SCRIPT_ID;
      script.src = "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js";
      script.async = true;
      script.dataset.id = "TkYwbkJ1WHRMSnZUYURLVzo1NS0zNTctNDk5LWVkdWFyZG8tcGVkcm8tbWVuZWdoZWw=";
      script.dataset.target = "ra-verified-seal";
      script.dataset.model = "2";
      document.body.appendChild(script);
    };
    if (!("IntersectionObserver" in window)) {
      carregar();
      return;
    }
    const observador = new IntersectionObserver((entradas) => {
      if (entradas.some((e) => e.isIntersecting)) {
        observador.disconnect();
        carregar();
      }
    }, { rootMargin: "400px" });
    observador.observe(target);
    return () => observador.disconnect();
  }, []);


  return (
    <footer className="bg-gray-900 text-white py-16 px-6">
      <div className="w-3/4 mx-auto">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <a href="/">
              <img src={logo}
              srcSet={`${logo352} 352w, ${logo} 640w`}
              sizes="160px" alt="Hawx Soluções" width="640" height="206" loading="lazy" className="w-40 h-auto mb-6" />
            </a>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Entendemos o seu problema, automatizamos processos, eliminamos gargalos e impulsionamos seus resultados com tecnologia que realmente funciona.
            </p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-6">Institucional</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/desenvolvimento-de-software" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faGear} className="mr-2" />
                  Desenvolvimento de software
                </a>
              </li>
              <li>
                <a href="/automacao-de-processos" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faGear} className="mr-2" />
                  Automação de processos
                </a>
              </li>
              <li>
                <a href="/diagnostico-de-processos" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faGear} className="mr-2" />
                  Diagnóstico de processos
                </a>
              </li>
              <li>
                <a href="/onde-atendemos" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faLocationDot} className="mr-2" />
                  Onde atendemos
                </a>
              </li>
              <li>
                <a href="/#missao-visao-valores" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faUser} className="mr-2" />
                  Sobre nós
                </a>
              </li>
              <li>
                <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsapp("rodape")} className="text-gray-400 hover:text-white transition">
                  <Icone icon={faMessage} className="mr-2" />
                  Fale conosco
                </a>
              </li>
              <li>
                <a href="/perguntas-frequentes" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faCircleQuestion} className="mr-2" />
                  Perguntas frequentes
                </a>
              </li>
              <li>
                <a href="/privacidade" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faShieldHalved} className="mr-2" />
                  Política de privacidade
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-6">Contato</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/software-em-orleans-sc" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faLocationDot} className="mr-2 inline-block" />
                  <span>Orleans, Santa Catarina</span>
                </a>
              </li>
              <li>
                <a href={whatsappUrl()} target="_blank" rel="noopener noreferrer" onClick={() => trackWhatsapp("rodape")} className="text-gray-400 hover:text-white transition">
                  <Icone icon={faWhatsapp} className="mr-2 inline-block" />
                  <span>(48) 99963-1298</span>
                </a>
              </li>
              <li>
                <a href="mailto:contato@hawx.com.br" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faEnvelope} className="mr-2 inline-block" />
                  <span>contato@hawx.com.br</span>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/hawxsolucoes/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition">
                  <Icone icon={faInstagram} className="mr-2 inline-block" />
                  <span>@hawxsolucoes</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            {`© ${copyrightYears} Hawx Soluções®. Todos os direitos reservados.`}
          </p>
          <div className="flex gap-6">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">{`Desde ${FOUNDED_YEAR} · CNPJ: 55.357.499/0001-80`}</p>
          </div>
        </div>

        <div className="flex justify-center mt-4">
          <div id="ra-verified-seal"></div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
